module.exports = __webpack_public_path__ + "img/TZS09525.65f6e981.jpeg";